import Storage from '@utils/storage'

export function isEmpty(value?: unknown): boolean {
  return (
    value === undefined ||
    value === null ||
    value === '' ||
    (typeof value === 'object' && !Object.keys(value).length) ||
    (Array.isArray(value) && !value.length)
  )
}

export function isBlank(value?: unknown): boolean {
  if (isEmpty(value)) return true
  if (typeof value === 'string' && value.replace(/\s/g, '') === '') return true
  return false
}

export function isPresent(value?: unknown): boolean {
  return !isBlank(value)
}

export function formatPageTitle(title?: string): string {
  if (!title) return 'Noteflight'
  return `${title} | Noteflight`
}

let _profileEpoch = ''
let _updateProfileEpoch = false

/**
 * Return a cache-busting epoch value that will force user's own profile data (typically just the avatar)
 * to be loaded anew after a change occurs.
 */
export function getProfileEpoch(): string | null {
  if (!_updateProfileEpoch) {
    return _profileEpoch || Storage.profileEpoch
  }

  // Update profile epoch
  _profileEpoch = new Date().getTime().toString()
  Storage.profileEpoch = _profileEpoch

  shouldUpdateProfileEpoch(false)
  return _profileEpoch
}

/**
 * Update profile epoch. Setting it to true will force it to update.
 */
export function shouldUpdateProfileEpoch(val: boolean) {
  _updateProfileEpoch = val
}
